import { Route, Routes } from "react-router-dom";
import DownstreamSummary from "../DownstreamSummary/DownstreamSummary";
import WorkInProgress from "../WorkInProgress/WorkInProgress";
import AdvancedSearch from "../AdvancedSearch/AdvancedSearch";
import ListSearch from "../ListSearch/ListSearch";
import Documents from "../Documents/documents";
import EmptyView from "../Documents/EmptyView";
import SimpleSearch from "../SimpleSearch/SimpleSearch";
import ElasticSearch from "../ElasticSearch/ElasticSearch";
import ArchiveSearch from "../ArchiveSearch/ArchiveSearch";
import DDExceptions from "../DDExceptions/DDExceptions";
import BulkReprocess from "../BulkOperations/BulkReprocess/BulkReprocess";
import TCMStatusSearch from "../TCMStatus/TCMStatusSearch";
import UserTable from "../UsersManagement/Users";
import GroupsTable from "../GroupsManagement/Groups";
import GroupActions from "../GroupsManagement/GroupActions";
import RolesActions from "../RolesManagement/RolesAction";
import UsersActions from "../UsersManagement/UsersActions";
import RolesTable from "../RolesManagement/Roles";
import FileLocation from "../FileLocation/FileLocation";
import CreateNew from "../FileLocation/CreateNew";
import PreworkSummary from "../PreworkSummary/PreworkSummary";
import UserActivity from "../UserActivity/UserActivity";
import EmailTemplate from "../EmailTemplate/EmailTemplate";
import EmailTemplateAction from "../EmailTemplate/EmailTemplateAction";
import MetadataFields from "../MetadataFields/metadataFields";
import MetadataFieldsAction from "../MetadataFields/MetadataFieldsAction";
import ColumnHeaders from "../ColumnHeaders/ColumnHeaders";
import MetaDataFieldHeader from "../MetaDataFieldHeader/MetaDataFieldHeader";
import PreworkDetail from "../PreworkDetail/PreworkDetail";
import ProcessStages from "../ProcessStages/ProcessStages";
import ProcessStageAction from "../ProcessStages/ProcessStageAction";
import Menus from "../Menus/Menus";
import MenusAction from "../Menus/MenusAction";
import SubSystemConfiguration from "../SubSystem/SubSystemConfiguration";
import SourceConfiguration from "../Source/SourceConfiguration";
import PerformanceReport from "../PerformanceReport/PerformanceReport";
import ArchivalReport from "../ArchivalReport/ArchivalReport";
import ActivityReport from "../ActivityReport/ActivityReport";
import MetadataGroupsMangement from "../MetadataGroupsMangement/MetadataGroupsMangement";
import MetadataGroupsMangementAction from "../MetadataGroupsMangementAction/MetadataGroupsMangementAction";
import MetadataMappingManagement from "../MetadataMappingManagement/MetadataMappingManagement";
import MetadatMappingManagementAction from "../MetadatMappingManagementAction/MetadatMappingManagementAction";
import Upload from "../PreworkDetail/Upload";
import Accounts from "../Accounts/Accounts";
import NewAccountConfiguration from "../Accounts/NewAccountConfiguration";
import ForbiddenPage from "../ForbiddenPage/ForbiddenPage";
import MetadataDefinitionManagement from "../MetadataDefinitionManagement/MetadataDefinitionManagement";
import MetadataDefinitionAction from "../MetadataDefinitionAction/MetadataDefinitionAction";
import EmailTemplateMapping from "../EmailTemplateMapping/EmailTemplateMapping";
import EmailTemplateMappingAction from "../EmailTemplateMapping/EmailTemplateMappingAction";
import FileInfoReport from "../FileInfoReport/FileInfoReport";
import Welcome from "../Home/Welcome.Component";
import AccessRights from "../AccessRights/AccessRights";
import ApiIngestion from "../ApiIngestion/ApiIngestion";
import PendingMessages from "../PendingMessages/PendingMessages";
import DecryptURL from "../DecryptURL/DecryptURL";

const RouteConfig: React.FC<any> = (userData: any, businessUnitData: any) => {
  return (
    <Routes>
      <Route path="" element={<Welcome />} />
      <Route path="/forbidden" element={<ForbiddenPage />} />
      {/* <Route path="/home" element={<Welcome />} /> */}
      <Route
        path="/downstream"
        element={
          <DownstreamSummary
            email={userData}
            businessUnitData={userData?.businessUnitData}
          />
        }
      />
      <Route path="/unmatchedassets" element={<WorkInProgress />} />
      <Route path="/advancedSearch" element={<AdvancedSearch />} />
      <Route path="/listsearch" element={<ListSearch />} />
      <Route path="/documents" element={<Documents />} />
      <Route path="/empty" element={<EmptyView />} />
      <Route path="/simpleSearch" element={<SimpleSearch />} />
      <Route path="/elasticsearch" element={<ElasticSearch />} />
      <Route path="/archivesearch" element={<ArchiveSearch />} />
      <Route path="/ddexceptions" element={<DDExceptions />} />
      <Route path="/bulkreprocess" element={<BulkReprocess />} />
      <Route
        path="/tcmstatussearch"
        element={
          <TCMStatusSearch
            email={userData}
            businessUnitData={userData?.businessUnitData}
          />
        }
      />
      <Route
        path="/user"
        element={<UserTable businessUnitData={userData?.businessUnitData} />}
      />
      <Route
        path="/groupview"
        element={<GroupsTable businessUnitData={userData?.businessUnitData} />}
      />
      <Route
        path="/groupEditAction"
        element={<GroupActions businessUnitData={userData?.businessUnitData} />}
      />
      <Route
        path="/rolesEditAction"
        element={<RolesActions businessUnitData={userData?.businessUnitData} />}
      />
      <Route
        path="/userEditAction"
        element={<UsersActions businessUnitData={userData?.businessUnitData} />}
      />
      <Route
        path="/roleview"
        element={<RolesTable businessUnitData={userData?.businessUnitData} />}
      />
      <Route path="/FileLocation" element={<FileLocation />} />
      <Route path="/createNew" element={<CreateNew />} />
      <Route path="/summary" element={<PreworkSummary email={userData} />} />
      <Route path="/userActivity" element={<UserActivity />} />
      <Route path="/email" element={<EmailTemplate />} />
      <Route
        path="/emailTemplateEditAction"
        element={<EmailTemplateAction />}
      />
      <Route path="/metadataitemdisplay" element={<MetadataFields />} />
      <Route path="/createNewMetaDataItem" element={<MetadataFieldsAction />} />
      <Route
        path="/columnheaders"
        element={<ColumnHeaders businessUnitData={businessUnitData} />}
      />
      <Route
        path="/metadata"
        element={<MetaDataFieldHeader businessUnitData={businessUnitData} />}
      />
      <Route path="/source" element={<SourceConfiguration />} />
      <Route path="/preworkdetails" element={<PreworkDetail />} />
      <Route
        path="/processStageDisplay"
        element={
          <ProcessStages businessUnitData={userData?.businessUnitData} />
        }
      />
      <Route
        path="/createprocessStage"
        element={
          <ProcessStageAction businessUnitData={userData?.businessUnitData} />
        }
      />
      <Route
        path="/menuItemDisplay"
        element={<Menus businessUnitData={userData?.businessUnitData} />}
      />
      <Route
        path="/createMenuItem"
        element={<MenusAction businessUnitData={userData?.businessUnitData} />}
      />
      <Route path="/subSystem" element={<SubSystemConfiguration />} />
      <Route
        path="/performancereport"
        element={
          <PerformanceReport businessUnitData={userData?.businessUnitData} />
        }
      />
      <Route
        path="/archivalreport"
        element={
          <ArchivalReport businessUnitData={userData?.businessUnitData} />
        }
      />
      <Route
        path="/activityReport"
        element={
          <ActivityReport businessUnitData={userData?.businessUnitData} />
        }
      />
      <Route
        path="/metadataGroupDisplay"
        element={
          <MetadataGroupsMangement
            businessUnitData={userData?.businessUnitData}
          />
        }
      />
      <Route
        path="/newMetadataGroup"
        element={
          <MetadataGroupsMangementAction
            businessUnitData={userData?.businessUnitData}
          />
        }
      />
      <Route
        path="/metadatamapping"
        element={
          <MetadataMappingManagement
            businessUnitData={userData?.businessUnitData}
          />
        }
      />
      <Route
        path="/createmapping"
        element={
          <MetadatMappingManagementAction
            businessUnitData={userData?.businessUnitData}
          />
        }
      />
      <Route path="/fileUpload" element={<Upload />} />
      <Route path="/account" element={<Accounts />} />
      <Route path="/newaccount" element={<NewAccountConfiguration />} />
      <Route
        path="/metadatadefinition"
        element={
          <MetadataDefinitionAction
            businessUnitData={userData?.businessUnitData}
          />
        }
      />
      <Route
        path="/metadatadefinitiondisplay"
        element={
          <MetadataDefinitionManagement
            businessUnitData={userData?.businessUnitData}
          />
        }
      />{" "}
      <Route path="/emailtemplatemapping" element={<EmailTemplateMapping />} />
      <Route
        path="/emailtemplatemappingcreate"
        element={<EmailTemplateMappingAction />}
      />
      <Route
        path="/fileinfoReports"
        element={
          <FileInfoReport businessUnitData={userData?.businessUnitData} />
        }
      />
      <Route path="/accessrights" element={<AccessRights />} />
      <Route path="/apiingestion" element={<ApiIngestion />} />
      <Route path="/pendingmessages" element={<PendingMessages />} />
      <Route path="/decrypturl" element={<DecryptURL />} />
    </Routes>
  );
};

export default RouteConfig;
